export default "__VITE_ASSET__NiGObsxs__"